<template lang="pug">
  .prj-media.w-full(:class="css")
    //- inner (text-width sized)
    div(:class="{'sm-w-12x18 lg-w-10x18 mx-auto px-12': frmt[0] === 'text-width'}")
      //- image folio
      template(v-if="slice.slice_type === 'image_folio'")
        imageset(:items="slice.items", :aspectRatio="aspectRatio", :truncate="truncCaption", :view="isBleed && !useOriginal ? 'full-bleed' : null", :inset="isBleed", :defer="defer", :original="useOriginal")
      //- vimeo
      template(v-else-if="slice.slice_type === 'vimeo'")
        vimeo-clip(:vimeoURL="slice.primary.vimeo_url", :clip="[slice.primary.clip_start, slice.primary.clip_end]", :aspectRatio="aspectRatio", :bgSize="vimeoIsBleed && 'cover'", @click="openViewer(slice.primary.vimeo_url)", :caption="slice.primary.caption", :truncate="truncCaption")
</template>

<script>
import Imageset from './Imageset'
import VimeoClip from './VimeoClip'
import Vue from 'vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Slice--Media',
  props: ['slice', 'next', 'prev', 'mediaIndex'],
  computed: {
    // the first two photo sets load straight away, the rest as the reader reaches them
    defer () {
      return this.mediaIndex > 1
    },
    ...mapGetters(['winIs']),
    format () {
      // '[width] : [landscape/portrait] : [float]'
      return (this.slice && this.slice.primary.format) || ''
    },
    frmt () {
      return this.format.split(' : ')
    },
    // "full-bleed : landscape (16:9)": edge to edge body image (E1 general item)
    isBleed () {
      return this.frmt[0] === 'full-bleed'
    },
    // Prismic "Image ratio" = Original ratio: show the whole photograph at its own shape
    // instead of cropping it into the format's ratio. Absent or "Format ratio" = as before.
    useOriginal () {
      const chosen = /original/i.test((this.slice && this.slice.primary.image_ratio) || '')
      // a full-bleed image on a portrait phone is also shown whole: the 16:9 crop cut the
      // photograph to the phone's width (Guido, 8 Oct 2026). Desktop keeps the full-bleed crop.
      return chosen || (this.isBleed && this.isPhonePortrait)
    },
    isPhonePortrait () {
      return this.$store.getters.isPortrait && this.$store.state.winW < Vue.config.bkpts.md
    },
    aspectRatio () {
      const frmt = this.format
      const is3x2 = frmt.includes('full') || frmt.includes('third')
      const isNativeWidthVimeo = this.slice.slice_type === 'vimeo' && !this.vimeoIsBleed
      return isNativeWidthVimeo ? 'none'
        : this.isBleed ? '16x9'
          : frmt.includes('portrait') ? '4x5'
            : is3x2 ? '3x2'
              : '4x3'
    },
    css () {
      const frmt = this.frmt
      const nxt = this.next || {}
      return [
        {
          'px-12': frmt[0] === 'full',
          'prj-media--bleed': this.isBleed,
          'px-12 md-w-1x2': frmt[0] === 'half',
          'px-12 md-w-1x3': frmt[0] === 'third',
          // MARGINS
          // header/quote:hero (deduction against 1/2 caption pb >> md-72)
          'md--mb-12': nxt.slice_type === 'header' || (nxt.slice_type === 'quote' && nxt.primary.format === 'hero'),
          // text/quote (addition w/ caption height >> md-72)
          'mb-24 md-mb-36': nxt.slice_type === 'text' || (nxt.slice_type === 'quote' && nxt.primary.format === 'default')
        }
      ]
    },
    truncCaption () {
      return !['full', 'full-bleed', 'text-width', 'third'].includes(this.frmt[0])
    },
    vimeoIsBleed () {
      return !['full', 'text-width'].includes(this.frmt[0])
    }
  },
  methods: {
    openViewer (url) {
      if (this.winIs('lg')) return this.$store.commit('OPEN_VIEWER', url)
    }
  },
  components: { Imageset, VimeoClip },
  inheritAttrs: false
}
</script>

<style>
/* pull a full-bleed image out past the project body's side padding (px-12 below lg, 11.8% at lg) */
.prj-media--bleed {
  margin-left: -1.2rem;
  margin-right: -1.2rem;
  width: calc(100% + 2.4rem);
}
@media (min-width: 1024px) {
  .prj-media--bleed {
    margin-left: -15.45%;
    margin-right: -15.45%;
    width: 130.9%;
  }
}
</style>
